import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Modal,
  Text,
  Spinner,
  Image,
  Loading,
  Button,
  DataTable,
  ButtonGroup,
  Toast,
  Checkbox,
  FormLayout,
  Filters,
  TextField,
  Badge,
  Frame,
  InlineError,
  ChoiceList,
  Thumbnail,
  EmptySearchResult,
  Select,
} from "@shopify/polaris";
import axios from "../../../Assets/Lib/axios";
import { useRef } from "react";
import emptyListImage from "../../../Assets/Images/emptyList.svg";
import { useNavigate, useLocation } from "react-router-dom";
import { MultiSelect } from "react-multi-select-component";
import Pagination from "@mui/material/Pagination";
import { useParams } from "react-router-dom";
import moment from "moment";
import { capitalizeFirstLetter } from "../../../Helpers";
import { EditIcon } from "@shopify/polaris-icons";

const BookingsCourse = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id, sessionId, classId } = useParams();
  const addEditState = useRef("");
  const perPage = 50;
  const [ts, setTs] = useState("");
  const [availability, setAvailability] = useState("");
  const [queryValue, setQueryValue] = useState("");
  const [page, setPage] = useState(1);
  const [pageObject, setPageObject] = useState({
    isLoading: true,
    isSaving: false,
    tableItems: [],
    tableTotalPages: 0,
    isListEmpty: false,
  });
  const handleAddItem = () => {
    navigate("/admin/packages/new");
  };
  function handleFiltersQueryChange(queryValue) {
    refBoolPage.current = false;
    setQueryValue(queryValue);
  }
  function handleAvailabilityChange(availability) {
    setAvailability(availability);
  }
  const handleAvailabilityRemove = useCallback(() => setAvailability(""), []);
  const handleQueryValueRemove = useCallback(() => setQueryValue(""), []);
  const handleFiltersClearAll = useCallback(() => {
    handleAvailabilityRemove();
    handleQueryValueRemove();
  }, [handleAvailabilityRemove, handleQueryValueRemove]);

  const filters = [
    {
      key: "availability",
      label: "Filter by",
      filter: (
        <ChoiceList
          title="Filter by"
          titleHidden
          choices={[{ label: "Email", value: "email" }]}
          selected={availability || []}
          onChange={handleAvailabilityChange}
        />
      ),
      shortcut: false,
    },
  ];

  const appliedFilters = [];
  if (!isEmpty(availability)) {
    const key = "availability";
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, availability),
      onRemove: handleAvailabilityRemove,
    });
  }
  const loadingMarkup = pageObject.isLoading ? <Loading /> : null;
  const emtyState = pageObject.isListEmpty ? (
    <div
      style={{
        display: "flex",
        justifyContent: "middle",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div style={{ width: "25%" }}>
        <Image src={emptyListImage}></Image>
      </div>
      <div className="mb-3">
        <Text variant="bodyLg" as="p">
          No results found
        </Text>
      </div>
      <br />
    </div>
  ) : (
    pageObject.isLoading && (
      <div className="spinnerContainer">
        <div className="vertical-center">
          <Spinner size="large" />
        </div>
      </div>
    )
  );
  const refBoolPage = useRef(true);
  const handleChangePage = (event, value) => {
    refBoolPage.current = true;
    setPage(value);
  };

  const handleEdit = (param) => {
    navigate(
      `/admin/courses/${id}/sessions/${sessionId}/bookings/edit/${param}`
    );
  };

  const [checkInValue, setCheckInValue] = useState("");
  const handleSelectChange = (id, newValue) => {
    axios
      .patch(`course-session-booking/${id}/toggle-check-in`, {
        checkin_status: newValue,
      })
      .then((result) => {
        // setIsSaving(false);
        setTs(+new Date());
        toggleActive();
      })
      .catch((error) => {});
  };
  useEffect(() => {
    fetchData();
  }, [ts, availability, queryValue, page]);
  const handleClickRow = (param) => {
    // navigate(
    //   `/admin/packages/${id}/subpackages/${subpackageId}/subscribers/${param}`
    // );
  };
  const parseName = (jsonObj) => {
    if (jsonObj?.submembership?.name) {
      return jsonObj.submembership.name;
    } else if (jsonObj?.subpackage?.name) {
      return jsonObj.subpackage.name;
    }
    return null;
  };
  async function fetchData() {
    let response = "";

    try {
      response = await axios.get(
        `${`/courses/${id}/sessions/${sessionId}/bookings`}?per_page=${perPage}&page=${
          refBoolPage.current ? page : 1
        }${
          queryValue
            ? `&filter[${
                availability === "" ? "email" : availability
              }]=${queryValue}`
            : ""
        }`
      );
      setPageObject({
        ...pageObject,
        tableItems: response.data.data.data.map((item, index) => [
          <div className="" onClick={() => handleClickRow(item.id)}>
            {item.user ? item.user.id : "-"}
          </div>,
          <div className="" onClick={() => handleClickRow(item.id)}>
            {item?.user && item?.user?.first_name
              ? `${item?.user?.first_name ? item?.user?.first_name : " "} ${
                  item?.user?.last_name ? item?.user?.last_name : " "
                }`
              : "-"}
          </div>,
          <div className="" onClick={() => handleClickRow(item.id)}>
            {item.user && item?.user?.email ? item.user.email : "-"}
          </div>,
          <div className="" onClick={() => handleClickRow(item.id)}>
            {item.user && item?.user?.phone_number
              ? item.user.phone_number
              : "-"}
          </div>,
          <div className="" onClick={() => handleClickRow(item.id)}>
            {item.user && item?.user?.birthday ? item.user.birthday : "-"}
          </div>,
          <div className="" onClick={() => handleClickRow(item.id)}>
            {item.course_type ? capitalizeFirstLetter(item.course_type) : "-"}
          </div>,
          // <div className="" onClick={() => handleClickRow(item.id)}>
          //   {item.user && item.user?.shoe_size !== null
          //     ? item.user?.shoe_size
          //     : "-"}
          // </div>,
          <div className="" onClick={() => handleClickRow(item.id)}>
            {item.seat && item.seat?.label !== null ? item.seat?.label : "-"}
          </div>,
          <div className="" onClick={() => handleClickRow(item.id)}>
            {item.payment_type ? capitalizeFirstLetter(item.payment_type) : "-"}
          </div>,
          // <div className="" onClick={() => handleClickRow(item.id)}>
          //   {parseName(item) ?? "-"}
          // </div>,
          // <div className="" onClick={() => handleClickRow(item.id)}>
          //   {item.amount !== null ? item.amount : "-"}
          // </div>,
          <div className="" onClick={() => handleClickRow(item.id)}>
            {item?.status ? (
              <Badge tone={switchStatusColor(item.status)}>
                {capitalizeFirstLetter(item?.status)}
              </Badge>
            ) : (
              "-"
            )}
          </div>,
          <Select
            options={[
              { label: "Enrolled", value: "enrolled" },
              { label: "Completed", value: "completed" },
              { label: "No Show", value: "no show" },
            ]}
            onChange={(newValue) => handleSelectChange(item.id, newValue)}
            value={item.checkin_status}
            placeholder="Please select"
          />,
          <div className="" onClick={() => handleClickRow(item.id)}>
            {item?.created_at
              ? moment(item?.created_at).format("YYYY-MM-DD HH:mm:ss")
              : "-"}
          </div>,
          <div className="" onClick={() => handleClickRow(item.id)}>
            {item?.updated_at
              ? moment(item?.updated_at).format("YYYY-MM-DD HH:mm:ss")
              : "-"}
          </div>,
          <ButtonGroup>
            <Button onClick={() => handleEdit(item.id)} icon={EditIcon}>
              Edit
            </Button>
          </ButtonGroup>,
        ]),
        isLoading: false,
        isListEmpty: !response.data.data.data.length ? true : false,
        tableTotalPages: response.data.data.total,
      });
    } catch (error) {
      console.log(error);
    }

    // if (!featuresList.length)
    //   try {
    //     responseFeatures = await axios.get(`features`);
    //     setFeaturesList(
    //       responseFeatures.data.data.data.map((item, index) => {
    //         return {
    //           label: item.name,
    //           value: item.id,
    //         };
    //       })
    //     );
    //   } catch (error) {
    //     console.log(error);
    //   }
  }

  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const [toastContent, setToastContent] = useState(
    "The check in status has been changed successfully"
  );

  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;
  const switchStatusColor = (param) => {
    switch (param) {
      case "pending":
        return `default`;
      case "confirmed":
        return `success`;
      case "cancelled":
        return `warning`;
      case "cancelled with charge":
        return `warning`;
      case "cancelled with no refund":
        return `warning`;
      case "failed":
        return `critical`;
      default:
        return "";
    }
  };
  const handleBook = () => {
    props?.type === "recent-sessions"
      ? navigate(`/admin/sessions/${id}/classes/${classId}/bookings/book`)
      : navigate(
          `/admin/${props.path}/${id}/sessions/${sessionId}/bookings/book`
        );
  };
  const handleWatingList = () => {
    props?.type === "recent-sessions"
      ? navigate(
          `/admin/sessions/${id}/classes/${classId}/bookings/waiting-list`
        )
      : navigate(
          `/admin/${props.path}/${id}/sessions/${sessionId}/waiting-list`
        );
  };
  return (
    <Page
      fullWidth
      title="Bookings"
      backAction={{
        onAction: () => navigate(`/admin/courses/${id}/sessions`),
      }}
      // primaryAction={
      //   props?.type === "sessions" || props?.type === "recent-sessions" ? (
      //     <ButtonGroup>
      //       <Button variant="primary" onClick={handleWatingList}>
      //         Waiting List
      //       </Button>
      //       <Button variant="primary" onClick={handleBook}>
      //         Book
      //       </Button>
      //     </ButtonGroup>
      //   ) : null
      // }
    >
      <Card padding="0">
        {loadingMarkup}

        {/* <Filters
          queryValue={queryValue}
          queryPlaceholder="Search..."
          filters={filters}
          appliedFilters={appliedFilters}
          onQueryChange={handleFiltersQueryChange}
          onQueryClear={handleQueryValueRemove}
          onClearAll={handleFiltersClearAll}
        /> */}

        <DataTable
          columnContentTypes={["text", "text", "text", "text"]}
          headings={[
            <Text variant="bodyMd" as="p" fontWeight="medium">
              User ID
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Username
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Email
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Phone Number
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Date of Birth
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Session Type
            </Text>,
            // <Text variant="bodyMd" as="p" fontWeight="medium">
            //   Shoe Size
            // </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Spot Booked
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Payment Method
            </Text>,
            // <Text variant="bodyMd" as="p" fontWeight="medium">
            //   Package / Membership
            // </Text>,
            // <Text variant="bodyMd" as="p" fontWeight="medium">
            //   Amount
            // </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Status
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Check in Status
            </Text>,

            <Text variant="bodyMd" as="p" fontWeight="medium">
              Created at
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Updated at
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium"></Text>,
          ]}
          rows={pageObject.tableItems}
          verticalAlign="middle"
          increasedTableDensity
          footerContent={
            pageObject.tableItems?.length &&
            `Showing ${pageObject.tableItems.length} of ${pageObject.tableTotalPages} results`
          }
          hasZebraStripingOnData
          // truncate
        />
        {emtyState}
        {Math.ceil(pageObject.tableTotalPages / perPage) >= 2 && (
          <div
            style={{
              paddingTop: "10px",
              textAlign: "center",
              paddingBottom: "10px",
            }}
          >
            <Pagination
              variant="outlined"
              count={Math.ceil(pageObject.tableTotalPages / perPage)}
              page={page}
              onChange={handleChangePage}
            />
            {/* <Pagination
              count={Math.ceil(pageObject.tableTotalPages / perPage)}
              page={page}
              onChange={handleChangePage}
              size="large"
            /> */}
          </div>
        )}

        {toastMarkup}
      </Card>
    </Page>
  );
  function disambiguateLabel(key, value) {
    switch (key) {
      case "taggedWith":
        return `Tagged with ${value}`;
      case "availability":
        return `Filter by ${value}`;
      default:
        return value;
    }
  }
  function isEmpty(value) {
    if (Array.isArray(value)) {
      return value.length === 0;
    } else {
      return value === "" || value == null;
    }
  }
  function getFirstNonNullValue(obj) {
    for (const value of Object.values(obj)) {
      if (value !== null) {
        return value;
      }
    }
    return null;
  }
};

export default BookingsCourse;
